// « Ma ville » (ADR-017, amendement du 2026-10-28) : chaque membre a une ville,
// Lyon par defaut ou estimee. La fenetre « Les sorties a {ville} t'interessent ? »
// demande de la confirmer, 48 h apres l'inscription. Regles pures, testees a part.

export const LOCATION_PROMPT_SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;
export const LOCATION_PROMPT_FIRST_DELAY_MS = 4000;
export const LOCATION_PROMPT_RETRY_MS = 5000;
// Laisse au nouveau membre le temps de decouvrir l'appli (et de changer sa
// ville lui-meme) avant de lui poser la question.
export const LOCATION_PROMPT_ACCOUNT_AGE_MS = 48 * 60 * 60 * 1000;
const STORAGE_PREFIX = "karango_location_prompt_v1";

function storageKey(userId) {
  return `${STORAGE_PREFIX}:${String(userId || "unknown")}`;
}

// Profil charge (le profil prive porte toujours isCustomLocation), membre reel,
// ville pas encore confirmee (isCustomLocation false), compte de plus de 48 h.
export function isLocationPromptEligible(user, now = Date.now()) {
  if (!user?.uid || user.isAnonymous || user.isSynthetic) return false;
  if (!Object.prototype.hasOwnProperty.call(user, "isCustomLocation")) return false;
  if (user.isCustomLocation) return false;
  const createdAt = Date.parse(user.createdAt || "");
  return !Number.isFinite(createdAt) || now - createdAt >= LOCATION_PROMPT_ACCOUNT_AGE_MS;
}

export function isLocationPromptSnoozed(userId, now = Date.now(), storage = safeStorage()) {
  try {
    const until = Number(storage?.getItem(storageKey(userId)));
    return Number.isFinite(until) && until > now;
  } catch {
    return false;
  }
}

export function snoozeLocationPrompt(userId, now = Date.now(), storage = safeStorage()) {
  try {
    storage?.setItem(storageKey(userId), String(now + LOCATION_PROMPT_SNOOZE_MS));
  } catch {
    // La memorisation ameliore le confort mais ne doit jamais bloquer l'app.
  }
}

// Jamais par-dessus une autre fenetre (notifications push, publication…).
export function isAnotherModalOpen(doc = typeof document !== "undefined" ? document : null) {
  return Boolean(doc?.querySelector('[aria-modal="true"]'));
}

export function canUseDeviceGeolocation() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  return Boolean(navigator.geolocation) && window.isSecureContext !== false;
}

function safeStorage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
}
